// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fk-a";
export var fulfillmentFormRail = "_fk-9";
export var headerTitleRow = "_fk-c";
export var orderDetailsWrapper = "_fk-7";
export var orderLinkTrigger = "_fk-2";
export var paymentInformationGrid = "_fk-h";
export var paymentSummaryColumn = "_fk-i";
export var shipmentContainer = "_fk-b";
export var shipmentDetailsMainPane = "_fk-8";
export var shipmentNavigationCard = "_fk-5";
export var shipmentNavigationRail = "_fk-3";
export var shipmentNavigationRailHeader = "_fk-4";
export var shipmentSummaryFact = "_fk-e";
export var shipmentSummaryGrid = "_fk-d";
export var shipmentSummaryMetadataRow = "_fk-f";
export var shipmentSummaryTags = "_fk-g";
export var shipmentWorkspace = "_fk-0";
export var shipmentWorkspaceContent = "_fk-6";
export var shipmentWorkspaceHeader = "_fk-1";